import { FC } from "react";

export const NotFound: FC = () => {
  return <div>
    <p>存在しないURLです</p>
  </div>
}